import { createStore as reduxCreateStore, applyMiddleware } from "redux";
import logger from "redux-logger";
import { composeWithDevTools } from "redux-devtools-extension";
import reducers from "./reducers";

const middlewares = [];
if (process.env.NODE_ENV !== "production") middlewares.push(logger);

export default function configureStore(initialState = {}) {
  const store = reduxCreateStore(
    reducers,
    initialState,
    composeWithDevTools(applyMiddleware(...middlewares))
  );

  store.asyncReducers = {}; // Async reducer registry
  return store;
}
